<script lang="ts">
	import MetaTitle from '$lib/components/meta/MetaTitle.svelte';
	import PageInfo from '$lib/components/page/PageInfo.svelte';
	import Button from '$lib/components/form/Button.svelte';
	import EditIcon from '$lib/components/icons/EditIcon.svelte';
	import PointCardPhoto from '$lib/components/point/PointCardPhoto.svelte';
	import { PUBLIC_SUPABASE_URL } from '$env/static/public';
	import { goto } from '$app/navigation';
	import Logo from '$lib/assets/logo/logo.svelte';
	import { fly } from 'svelte/transition';
	import { sineOut } from 'svelte/easing';
	import Edit from '$lib/assets/icons/edit.svelte';
	import { page } from '$app/stores';

	export let data;

	let link = data.link;
	$: link;
	let point: any = data.link.point;
	let isOccupied = data.isOccupied;
	let isOwner = data.isOwner;
	let isLinked = data.isLinked;
	let cookiesQuestions = data.cookiesQuestions;
	// let is_subscription: boolean = true;
	$: is_subscription = true;
	let isSubscription = data.isSubscription;

	$: isSubscription.then((value) => {
		is_subscription = value ?? false;
	});

	const deleteCookies = async () => {
		let response = await fetch('/api/cookies/delete', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ name: 'questions' })
		});
		if (response.ok) {
			goto('/').then(() => {
				goto('/' + link.link_nanoid);
			});
		}
	};
</script>

<MetaTitle title="{point?.name ?? 'Cсылка'} " />

<svelte:head>
	<meta name="description" content={point?.content ?? "qrot, qr-коды, микросайты, qrot.link"}>
	<meta property="og:site_name" content={ point?.address ?? 'https://qrot.link'} />
	<meta property="og:title" content="{point?.name ?? 'Ссылка на микросайт'}" />
	<meta property="og:url" content="{$page.url.toString()}" />
	<meta property="og:description" content={point?.content} />
	<meta property="og:type" content="website" />
	<meta property="og:image" content="https://qrot.link/qrot_logo.png" />
</svelte:head>

{#if link}
	{#if data.session}
		{#if isOccupied && isOwner && isLinked}
			<a href="/user/points/{point.nanoid}/edit/general">
				<div
					class="absolute right-3 top-3 h-8 w-8 p-2 text-primary-100 bg-primary-500 rounded-full shadow-lg hover:opacity-85"
				>
					<div class="block"><Edit /></div>
				</div>
			</a>

			<PointCardPhoto
				{is_subscription}
				{point}
				{cookiesQuestions}
				color={point.color}
				link_nanoid={link.link_nanoid}
				bg={point.wallpaper
					? PUBLIC_SUPABASE_URL + '/storage/v1/object/public/wallpapers/primary/' + point.wallpaper
					: PUBLIC_SUPABASE_URL + '/storage/v1/object/public/wallpapers/primary/' + '1.jpg'}
			/>

			{#if cookiesQuestions}
				<button
					class="absolutse p-2 {point.is_dark
						? 'text-base-200'
						: 'text-base-950'}  underline text-xs"
					on:click={deleteCookies}
				>
					Очистить ответы
				</button>
			{/if}

			{#if !is_subscription}
				<div
					in:fly={{ delay: 0, duration: 100, easing: sineOut }}
					class=" opacity-20 absolute z-10 bottom-3 w-full md:max-w-96"
				>
					<div class="flex items-center justify-center">
						<div class="w-10">
							<Logo />
						</div>
					</div>
				</div>
			{/if}
		{:else if isOccupied && isOwner && !isLinked}
			<PageInfo
				title="Это ваша ссылка!"
				{link}
				text="Для использования прикрепите ее к микросайту. Сначала микросайт необходимо создать"
			>
				<div class="pt-4">
					<Button href="/user/links/{link.link_nanoid}" title="Выбрать микросайт" />
				</div></PageInfo>
		{:else if isOccupied && !isOwner && !isLinked}
			<PageInfo
				title="Ссылка уже занята"
				{link}
				text="Ссылка занята другим пользователем, но не прикреплена к микросайту. Попробуйте зайти позже..."
			></PageInfo>
		{:else if !isOccupied && !isLinked}
			<PageInfo
				title="Свободная ссылка"
				{link}
				text="Для использования ссылки войдите в учетную запись и присоедините его к своему аккаунту"
			>
				<div class="pt-4">
					<Button href="/user/links/{link.link_nanoid}" title="Забрать ссылку" />
				</div></PageInfo
			>
		{:else}
			<PointCardPhoto
				{is_subscription}
				{cookiesQuestions}
				color={point.color}
				point={link.point}
				link_nanoid={link.link_nanoid}
				bg={point.wallpaper
					? PUBLIC_SUPABASE_URL + '/storage/v1/object/public/wallpapers/primary/' + point.wallpaper
					: PUBLIC_SUPABASE_URL + '/storage/v1/object/public/wallpapers/primary/' + '1.jpg'}
			/>
		{/if}
	{:else}
		{#if isOccupied}
			{#if isLinked}
				<PointCardPhoto
					{is_subscription}
					{cookiesQuestions}
					color={point.color}
					point={link.point}
					link_nanoid={link.link_nanoid}
					bg={point.wallpaper
						? PUBLIC_SUPABASE_URL +
							'/storage/v1/object/public/wallpapers/primary/' +
							point.wallpaper
						: PUBLIC_SUPABASE_URL + '/storage/v1/object/public/wallpapers/primary/' + '1.jpg'}
				/>
			{:else}
				<PageInfo
					title="Ссылка уже занята"
					sticker={link}
					text="Если это ваша ссылка, войдите и прикрепите ее к микросайту"
					><div class="pt-4">
						<Button href="/auth/signIn" title="Войти" />
					</div></PageInfo
				>
			{/if}
		{:else}
			<PageInfo
				title="Свободная ссылка"
				sticker={link.point}
				text="Для использования ссылки войдите в учетную запись и присоедините ее к своему аккаунту"
			>
				<div class="pt-4">
					<Button href="/user/links/{link.link_nanoid}" title="Забрать ссылку" />
				</div></PageInfo
			>
		{/if}
		<!-- Если юзер НЕ авторизован -->
	{/if}
{:else}
	Ссылка не существует
{/if}
